// 阿拉伯语
import ar from '../JsonLang/ar.json'
import arSpec from '../JsonLangSpec/ar.json'
export const lang = {
  ...ar, ...arSpec
}
